import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const HowWalletsWorkIllustration = (props: SVGProps) => {
  const { className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="142"
      height="154"
      fill="none"
      viewBox="0 0 142 154"
      {...restProps}
    >
      <g clipPath="url(#clip0_879_7980)">
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="0.73"
          d="m108.357 82.83-75.872 2.2"
        />
        <path
          fill="#000"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M65.687 102.94 93.67 19.108 54.874 6.158 26.89 89.988z"
        />
        <path
          fill="#000"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="0.73"
          d="m68.36 116.977 70.117-53.802-24.9-32.45-70.116 53.802z"
        />
        <path
          fill="#000"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="m70.598 89.417 10.33-28.598 30.304-2.575-10.33 28.598z"
        />
        <path
          fill="#000"
          d="M59.667 105.657c6.308-4.837 14.868-3.421 19.705 2.875z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="0.73"
          d="M59.667 105.657c6.308-4.837 14.868-3.421 19.705 2.875"
        />
        <path
          fill="#000"
          d="M54.346 75.912c4.838 6.308 4.045 15.029-2.263 19.866z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2.2"
          d="M54.346 75.912c4.838 6.308 4.045 15.029-2.263 19.866"
        />
        <path
          fill="#000"
          d="M122.205 41.982c-6.307 4.838-14.964 3.368-19.802-2.939z"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M122.205 41.982c-6.307 4.838-14.964 3.368-19.802-2.939"
        />
        <path
          fill="#000"
          d="M127.419 71.663c-4.838-6.307-3.948-14.974 2.36-19.802z"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M127.419 71.663c-4.838-6.307-3.948-14.974 2.36-19.802"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="0.73"
          d="M91.237 79.59a6.876 6.876 0 1 0 0-13.751 6.876 6.876 0 0 0 0 13.752Z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="m68.36 116.977 70.117-53.802-24.9-32.45-70.116 53.802z"
        />
        <path
          fill="#fff"
          d="M106.351 33.948c0-11.532-9.354-20.885-20.885-20.885S64.58 22.416 64.58 33.948c0 11.531 9.354 20.885 20.886 20.885 11.542 0 20.885-9.354 20.885-20.885"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M85.466 50.586c-9.193 0-16.638-7.445-16.638-16.638s7.445-16.637 16.638-16.637c9.182 0 16.637 7.444 16.637 16.637s-7.455 16.638-16.637 16.638Z"
        />
        <path
          fill="#fff"
          d="M118.344 153.446H39.823c-.269 0-.537 0-.794-.021-6.63-.279-11.79-5.922-11.79-12.562V75.525s3.659 7.305 12.594 7.305h78.511z"
        />
        <path
          fill="currentColor"
          d="M101.599 110.303h16.745v14.781h-16.745c-4.076 0-7.391-3.314-7.391-7.39a7.4 7.4 0 0 1 7.391-7.391"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M118.344 125.084h-16.745a7.39 7.39 0 1 1 0-14.781h7.873M27.24 117.693h46.566"
        />
        <path
          fill="#000"
          d="M73.677 120.279a2.585 2.585 0 1 0 0-5.171 2.585 2.585 0 0 0 0 5.171"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M27.24 127.305h33.65v15.522"
        />
        <path
          fill="#000"
          d="M60.89 145.283a2.586 2.586 0 1 0 0-5.172 2.586 2.586 0 0 0 0 5.172"
        />
        <path
          fill="currentColor"
          d="M33.365 99.918c-7.209-2.832-13.795-6.865-18.537-11.349C9.078 83.131 6.032 77.06 6.032 71V42.217l28.212-12.304 28.062 12.261v28.823c0 6.05-3.036 12.133-8.796 17.571-4.741 4.484-11.328 8.517-18.536 11.35l-.805.31z"
        />
        <path
          fill="#000"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.19"
          d="M34.17 60.079a6.661 6.661 0 1 0 0-13.323 6.661 6.661 0 0 0 0 13.323Z"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M34.17 83.399V56.281M38.589 75.46H34.05M38.589 79.462H34.05"
        />
        <path
          fill="#000"
          d="m91.987 29.754-6.522-2.961-6.51 2.96v8.4l6.51 2.96 6.522-2.96z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M14.828 88.57c-5.75-5.439-8.796-11.51-8.796-17.571v-28.78l19.641-8.571"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="m127.698 11.229-7.316 9.15M127.815 26.793l13.173-5.299M113.13 14.757 115.104.705"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="1.97"
          d="m1.291 107.159 8.356-6.919M15.858 103.619l-2.971 10.867"
        />
      </g>
      <defs>
        <clipPath id="clip0_879_7980">
          <path fill="#fff" d="M.615.555h140.77v152.89H.615z" />
        </clipPath>
      </defs>
    </svg>
  );
};
